<div class="refactor-card-container">
  <div class="refactor-card-content">
    <ng-content></ng-content> <!-- Aquí se inyectará el contenido de los otros componentes -->
  </div>
</div>
